<template>
	<div class="flex flex-col justify-between grow">
		<div class="w-full flex flex-col items-start justify-start max-h-[550px] overflow-auto">
			<div class="text-[14px] font-semibold mt-[15px]">Event name</div>
			<div
				class="w-full text-[14px] font-normal text-[#1B1C21] rounded-md border border-[#DFE4EF] bg-[#F9FAFC] pl-[15px] py-[8px] mb-[17px]"
				v-if="currentEvent.is_default"
			>
				{{ currentEvent.title }}
			</div>
			<AppTextField class="w-full mt-[5px]" v-model="currentEvent.title" outlined hide-details placeholder="Enter event name" v-else />
			<div v-if="currentEvent.is_default" class="text-[14px] font-semibold my-[15px]">Default Parameters</div>
			<div v-for="(item, i) in defaultParams" :key="i" class="w-full mb-[25px]">
				<div class="text-[14px] font-normal text-[#1B1C21] rounded-md border border-[#DFE4EF] bg-[#F9FAFC] pl-[15px] py-[8px] mb-[8px]">
					{{ item.name }}
				</div>
				<div class="text-[14px] font-normal text-[#1B1C21] rounded-md border border-[#DFE4EF] bg-[#F9FAFC] pl-[15px] py-[8px]">
					{{ item.type }}
				</div>
			</div>
			<div v-if="showIdentifier" class="w-full">
				<h3 class="font-semibold mt-[15px]">Event identifier</h3>
				<AppTextField
					class="w-full mt-[5px]"
					v-model="additional_data.identifier"
					outlined
					hide-details
					placeholder="Enter event identifier"
				/>
			</div>
			<h3 v-if="showCustomParams" class="font-semibold mt-[15px]">Custom Parameters</h3>
			<h5 v-if="showCustomParams" class="text-[#26262680] font-normal">
				When you add this event to your feature, you’ll be able to map data from the workflow into these parameters
			</h5>
			<div v-for="(item, i) in currentEvent.params" :key="i" class="w-full">
				<div class="flex flex-row items-center justify-between bg-[#F9FAFC] p-[10px] rounded mb-[15px]" v-if="!item.is_default">
					<div class="w-full flex-grow">
						<AppTextField v-model="item.name" class="w-full" outlined hide-details placeholder="Parameter name" />
						<AppSelect
							outlined
							hide-details
							placeholder="Parameter type"
							:items="paramTypes"
							v-model="item.type"
							item-value="type"
							:menu-props="{ bottom: true, offsetY: true, contentClass: 'apps-select-empty-state-menu' }"
						>
							<template v-slot:prepend-inner>
								<SIcon class="inner-prepended-data-type" :name="`${paramTypes.icon}`" />
							</template>
							<template v-slot:item="{ item }">
								<div class="flex-start--center">
									<SIcon class="inner-prepended-data-type mt-1 mr-3" :name="`${item.icon}`" />
									<div>{{ item.text }}</div>
								</div>
							</template>
						</AppSelect>
					</div>
					<RoundButton
						class="conf-btn mb-[12px] ml-[10px]"
						@click="
							() => {
								removeParam(i);
							}
						"
						><RemoveSvg
					/></RoundButton>
				</div>
			</div>
			<div v-if="showCustomParams" class="text-[12px] text-[#5B5BE7] cursor-pointer underline" @click="addParams">+ Add Parameter</div>
		</div>
		<div class="dialog-content flex flex-col items-center justify-end">
			<PrimaryButton class="text-[14px] font-normal w-[120px]" @click="handleSave" :loading="isLoading" :disabled="isDisabled"
				>Save event</PrimaryButton
			>
		</div>
	</div>
</template>

<script>
import RemoveSvg from '@/components/BlockEditorWidget/FieldSettings/EndRunButtonsFieldSettings/assets/RemoveSvg.vue';

export default {
	name: 'EventEdit',
	components: {
		RemoveSvg,
	},
	props: {
		event: { type: Object, required: false },
		showCustomParams: { type: Boolean, default: true, required: false },
		showIdentifier: { type: Boolean, default: false, required: false },
	},
	methods: {
		addParams() {
			this.currentEvent.params.push({ name: '', is_default: false, type: '' });
		},
		removeParam(index) {
			this.currentEvent.params.splice(index, 1);
		},
		addEvent() {
			const event = { ...this.currentEvent };
			if (this.showIdentifier) {
				event.additionalData = this.additional_data;
			}
			this.$emit('addEvent', event);
		},
		editEvent() {
			const event = { ...this.currentEvent };
			if (this.showIdentifier) {
				event.additionalData = this.additional_data;
			}
			this.$emit('editEvent', event);
		},
		handleSave() {
			this.isLoading = true;
			if (this.event) {
				this.editEvent();
			} else {
				this.addEvent();
			}
			this.isLoading = false;
		},
	},
	computed: {
		defaultParams() {
			return this.currentEvent.params.filter((item) => item.is_default);
		},
		isDisabled() {
			if (!this.currentEvent.title) {
				return true;
			}
			for (const param of this.currentEvent.params) {
				if (!param.name || !param.type) {
					return true;
				}
			}
			return this.showIdentifier && this.additional_data.identifier === '';
		},
	},
	data() {
		return {
			currentEvent: this.event || { title: '', is_default: false, params: [] },
			paramTypes: [
				{ text: 'String', type: 'string', icon: 'data-type-text' },
				{ text: 'List', type: 'array', icon: 'data-type-array' },
				{ text: 'Table', type: 'object', icon: 'action-table-data' },
			],
			isLoading: false,
			additional_data: this.event?.additional_data || {
				identifier: '',
			},
		};
	},
};
</script>

<style lang="scss"></style>
